module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-order-detail"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop_order_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Comfirm Order')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Comfirm Order Detail')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryConsumableItemName),
      expression: "queryConsumableItemName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "消耗品名"
    },
    domProps: {
      "value": _vm._s(_vm.queryConsumableItemName)
    },
    on: {
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.getShopOrderDetails($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryConsumableItemName = $event.target.value
      }
    }
  })]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.querySupplierName),
      expression: "querySupplierName"
    }],
    staticClass: "form-control margin-left",
    on: {
      "change": function($event) {
        _vm.querySupplierName = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全サプライヤー")]), _vm._l((_vm.shopOrderSuppliers), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  })], 2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryHoldOnPlaceName),
      expression: "queryHoldOnPlaceName"
    }],
    staticClass: "form-control margin-left",
    on: {
      "change": function($event) {
        _vm.queryHoldOnPlaceName = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全保管場所")]), _vm._l((_vm.shopOrderHoldOnPlaces), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  })], 2), _c('button', {
    staticClass: "btn btn-info margin-left",
    on: {
      "click": function($event) {
        _vm.getShopOrderDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('span', [_vm._v("絞り込んで表示")])])])])])]), (_vm.getShopOrderFlug && _vm.getShopOrderDetailsFlug) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v(_vm._s(_vm.shopOrder.shop_name))]), _c('span', {
    staticClass: "text-danger text-lg"
  }, [_vm._v(_vm._s(_vm.shopOrder.status_ja))])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.shopOrder.status === 'head_office_confirmed'
    },
    on: {
      "click": function($event) {
        _vm.updateShopOrder('head_office_confirmed')
      }
    }
  }, [_vm._v("承認")]), _c('button', {
    staticClass: "btn btn-danger btn-lg margin-right",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.isDisabledReject,
      "data-toggle": "modal",
      "data-target": "#order_completed_confirm_modal"
    }
  }, [_vm._v("否認")])])]), (_vm.isCanNotOrder()) ? _c('div', {
    staticClass: "row text-right"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("※発注不可の商品(灰色表示)が含まれています")])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('h4', [_vm._v(_vm._s(_vm.shopOrder.year_month_week))])]), (_vm.shopOrder.status == 'order_completed') ? _c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "text-left text-danger"
  }, [_vm._v("※" + _vm._s(_vm.shopOrder.order_completed_date_format) + "本部発注済")])]) : _c('div', {
    staticClass: "col-sm-5"
  }), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "text-right"
  }, [_vm._v("合計金額(税別)：" + _vm._s(_vm.formatedTotalPrice) + "円")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', [_vm._v(_vm._s(_vm.$t('Consumable Item Info')))]), _c('th', [_vm._v(_vm._s(_vm.$t('Master Supplier')))]), _c('th', [_vm._v(_vm._s(_vm.$t('consumableItem.label.just stock number')))]), _c('th', [_vm._v(_vm._s(_vm.$t('consumableItem.label.stock quantity')))]), _c('th', [_vm._v(_vm._s(_vm.$t('consumableItem.label.order quantity')))]), _c('th', [_vm._v(_vm._s(_vm.$t('consumableItem.label.price')) + "(税別)")]), _c('th', [_vm._v("小計(税別)")]), _c('th', [_vm._v("保管場所")]), _c('th', [_vm._v("在庫確認者")]), _c('th', [_vm._v("備考")])])]), _c('tbody', [_vm._l((_vm.shopOrderDetails), function(shopOrderDetail, index) {
    return _c('shop-order-detail-record', {
      key: index,
      attrs: {
        "shop-order-detail": shopOrderDetail,
        "index": index,
        "status": _vm.shopOrder.status,
        "is-zero-infinity-send-cost": _vm.isZeroInfinitySendCost
      },
      on: {
        "update-order-lot-quantity": _vm.updateOrderLotQuantity,
        "set-order-lot-quantity": _vm.setOrderLotQuantity,
        "update-stock-quantity": _vm.updateStockQuantity,
        "set-stock-quantity": _vm.setStockQuantity
      }
    })
  }), (_vm.isZeroInfinitySendCost) ? _c('tr', [_c('td', {
    staticClass: "text-danger",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(("ゼロインフィニティの消耗品(赤色表示)の合計が" + (_vm.zeroInfinityConstant.boundaryPrice.toLocaleString()) + "円以下のため送料が発生しています")))]), _c('td', [_vm._v(_vm._s(_vm.zeroInfinityConstant.sendPrice))]), _c('td', [_vm._v(_vm._s(_vm.zeroInfinityConstant.sendPrice))]), _c('td'), _c('td'), _c('td')]) : _vm._e()], 2)])])])]) : _vm._e(), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "order_completed_confirm_modal",
      "role": "dialog",
      "data-backdrop": "static",
      "aria-labelledby": "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("否認")])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "col-sm-9 margin-top",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#send_modal"
    },
    on: {
      "click": function($event) {
        _vm.updateShopOrder('head_office_reject')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-info margin-left",
    attrs: {
      "data-dismiss": "modal",
      "rightmargin": "30"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("本当に否認しますか？否認した場合は必ず店舗へご連絡下さい。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3cc4cfa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shop-order-detail.pug
// module id = 872
// module chunks = 1